import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        this.props.trackEvent(['Site Interaction', 'Open', 'Benefits']);
    }

    /* eslint-disable max-len */
    render({ close }) {
        return (
            <benefits-modal>
                <dialog-header>
                    <button onClick={close}>×</button>
                    <h1 className='fancy-title has-text-center'>
                        Your Personal<br />Journey Starts Here
                    </h1>
                    <p className='has-text-center has-margin-0-bottom'>
                        Discover the many benefits of your<br />Tarot.com Membership
                    </p>
                </dialog-header>
                <dialog-content>
                    <row>
                        <column className='is-4 has-text-center has-padding-10-left-desktop has-padding-10-left-tablet has-padding-10-right-desktop has-padding-10-right-tablet has-padding-5-mobile'>
                            <a href='/articles/karma-coins' onClick={() => this.trackClick('Free KCs')}>
                                <img
                                    src='https://gfx.tarot.com/images/icons/signup/karma-coins.svg'
                                    alt='Karma Coins'
                                    className='has-margin-10-left-desktop has-margin-10-right-desktop has-margin-10-left-tablet has-margin-10-right-tablet'
                                />
                                <p className='has-text-color-black has-margin-5-bottom has-text-size-14-mobile has-line-height-19-mobile has-line-height-22-desktop has-line-height-22-tablet'>
                                    20 FREE<br />Karma Coins
                                </p>
                            </a>
                            <a href='/articles/karma-coins' className='has-text-size-11-tiny' onClick={() => this.trackClick('Free KCs')}>Learn More</a>
                        </column>
                        <column className='is-4 has-text-center has-padding-10-left-desktop has-padding-10-left-tablet has-padding-10-right-desktop has-padding-10-right-tablet has-padding-5-mobile'>
                            <a href='/readings-reports/free' onClick={() => this.trackClick('Free Readings')}>
                                <img
                                    src='https://gfx.tarot.com/images/icons/signup/free-tarot-reading.svg'
                                    alt='Free Tarot Reading'
                                    className='has-margin-10-left-desktop has-margin-10-right-desktop has-margin-10-left-tablet has-margin-10-right-tablet'
                                />
                                <p className='has-text-color-black has-margin-5-bottom has-text-size-14-mobile has-line-height-19-mobile has-line-height-22-desktop has-line-height-22-tablet'>
                                    FREE<br className='is-visible-mobile' /><span className='is-hidden-mobile'> </span>Readings
                                    <span className='is-hidden-mobile'><br />and Reports</span>
                                </p>
                            </a>
                            <a href='/readings-reports/free' className='has-text-size-11-tiny' onClick={() => this.trackClick('Free Readings')}>Explore All</a>
                        </column>
                        <column className='is-4 has-text-center has-padding-10-left-desktop has-padding-10-left-tablet has-padding-10-right-desktop has-padding-10-right-tablet has-padding-5-mobile'>
                            <a href='/daily-horoscope' onClick={() => this.trackClick('Personal Content')}>
                                <img
                                    src='https://gfx.tarot.com/images/icons/signup/daily.svg'
                                    alt='Daily'
                                    className='has-margin-10-left-desktop has-margin-10-right-desktop has-margin-10-left-tablet has-margin-10-right-tablet'
                                />
                                <p className='has-text-color-black has-margin-5-bottom has-text-size-14-mobile has-line-height-19-mobile has-line-height-22-desktop has-line-height-22-tablet'>
                                    Personalized<br />Daily Content
                                </p>
                            </a>
                            <a href='/daily-horoscope' className='has-text-size-11-tiny' onClick={() => this.trackClick('Personal Content')}>Read Now</a>
                        </column>
                    </row>
                    <row className='has-margin-15-top has-margin-15-top-mobile'>
                        <column className='is-12 has-text-center'>
                            <a className='button button-pink-alternate' href='/member/benefits' onClick={() => this.trackClick('More Goodies')}>MORE GOODIES HERE</a>
                        </column>
                    </row>
                    <row className='has-margin-10-top'>
                        <column className='is-12 has-text-center'>
                            <a href='#' onClick={(e) => { this.trackClick('Back to what I was doing', 'Close'); this.close(e); }}>Back to what I was doing</a>
                        </column>
                    </row>
                </dialog-content>
            </benefits-modal>
        );
    }
    /* eslint-enable max-len */

    close = (e) => {
        e.preventDefault();
        this.props.close();
    }

    trackClick = (label, action = 'Click') => {
        this.props.trackEvent(['Site Interaction', action, `Benefits: ${label}`]);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
